import React from 'react'
import dynamic from "next/dynamic"
import { Location} from 'components/MapHere'

const FACILITY_PIN: string = '/static/images/map-facility-icon.png'

const MapHere = dynamic(() => import('components/MapHere'), { ssr: false })

interface FacilityMapProps {
    marker: Location
}

const FacilityMap: React.FC<FacilityMapProps> = ({ marker }) => {
    const center = { lat: Number(marker.lat), lng: Number(marker.lng) }

    return (
        <div className="facility-homepage-map mb-3">
            <MapHere
                id="regular"
                addInfoBubble={false}
                height="170px"
                width="100%"
                icon={FACILITY_PIN}
                locations={[marker]}
                center={center}
            />
        </div>
    );
};

export default FacilityMap;
